module.exports = __webpack_public_path__ + "img/5.e4d2d844.jpg";